import { Account } from '@treasury/domain/dashboard';
import { TmBaseComponent } from '@treasury/presentation';
import { closeIcon, gripDotsIcon } from '@treasury/presentation/assets/icons';
import '@vaadin/grid';
// eslint-disable-next-line no-duplicate-imports
import { GridDragStartEvent, GridDropEvent } from '@vaadin/grid';
import { css, html, nothing } from 'lit';
import { columnBodyRenderer } from 'lit-vaadin-helpers';
import { customElement, property, state } from 'lit/decorators.js';

export const tagName = 'order-group-accounts-table';

@customElement(tagName)
export class OrderGroupAccountsTable extends TmBaseComponent {
    @property({ type: Array })
    public accounts: Account[] = [];

    @state()
    private draggedItem?: Account;

    protected render() {
        if (!this.accounts.length) {
            return nothing;
        }
        return html`<vaadin-grid
            all-rows-visible
            rows-draggable
            .items=${this.accounts}
            .dropMode=${this.draggedItem ? 'between' : undefined}
            @grid-dragstart="${(event: GridDragStartEvent<Account>) => {
                [this.draggedItem] = event.detail.draggedItems;
            }}"
            @grid-dragend="${() => {
                this.draggedItem = undefined;
            }}"
            @grid-drop="${(event: GridDropEvent<Account>) => {
                const { dropTargetItem, dropLocation } = event.detail;
                // Only update when dropping on another item
                if (this.draggedItem && dropTargetItem !== this.draggedItem) {
                    const draggedItemIndex = this.accounts.indexOf(this.draggedItem);
                    this.accounts.splice(draggedItemIndex, 1);
                    const dropIndex =
                        this.accounts.indexOf(dropTargetItem) + (dropLocation === 'below' ? 1 : 0);
                    this.accounts.splice(dropIndex, 0, this.draggedItem);
                    this.accounts = [...this.accounts];

                    this.dispatchEvent(
                        new CustomEvent('accounts-reordered', {
                            detail: {
                                accounts: this.accounts,
                                updatedAccount: this.draggedItem,
                                newIndex: dropIndex,
                            },
                        })
                    );
                }
            }}"
            ><vaadin-grid-column ${columnBodyRenderer(this.renderAccount, [])}></vaadin-grid-column
        ></vaadin-grid>`;
    }

    private renderAccount(account: Account) {
        return html`<div class="bg-page py-1">
            <div class="flex justify-between bg-primary rounded-lg py-1.5 pl-4 pr-2 shadow">
                <div class="flex items-center">
                    <tm-icon .icon=${gripDotsIcon} color="#70757A"></tm-icon>
                </div>
                <div class="flex items-center grow px-4">
                    <div class="text-start h-[55px] flex flex-col items-start justify-center">
                        <span>${account.name}</span>
                        <span class="text-xs text-secondary">(${account.number})</span>
                    </div>
                </div>
                <div class="flex items-center">
                    <tm-button
                        importance="tertiary"
                        @click=${() => {
                            const index = this.accounts.indexOf(account);
                            // account.isRemoved = true;
                            this.accounts.splice(index, 1);
                            this.accounts = [...this.accounts];
                            this.dispatchEvent(
                                new CustomEvent('account-removed', {
                                    detail: { account, accounts: this.accounts },
                                })
                            );
                        }}
                        ><tm-icon .icon=${closeIcon} color="#70757A"></tm-icon
                    ></tm-button>
                </div>
            </div>
        </div>`;
    }

    public static get styles() {
        return [
            css`
                vaadin-grid-cell-content {
                    padding: 0;
                }
            `,
        ];
    }
}

declare global {
    interface HTMLElementTagNameMap {
        [tagName]: OrderGroupAccountsTable;
    }
}
